export const isOfficialWhatsappConnection = (whatsapp) => {
  if (!whatsapp) return false;
  
  return whatsapp.tokenWhatsappIntegration && 
      whatsapp.tokenWhatsappIntegration.trim() !== "" &&
      whatsapp.tokenAccountWhatsappIntegration && 
      whatsapp.tokenAccountWhatsappIntegration.trim() !== ""
};

export const isNotificameConnection = (whatsapp) => {
  if (!whatsapp) return false;
  return whatsapp.connectorType === 1;
};